import React, { useState, useEffect } from "react";
import axios from "./axios";
import request from "./request";
import "./banner.css";

function Banner() {
  const [movie, setMovie] = useState([]);

  useEffect(() => {
    async function getRandomMovie() {
      const req = await axios.get(request.fetchNetflixOriginals);
      const ranNo = Math.floor(Math.random() * req.data.results.length - 1);
      setMovie(req.data.results[ranNo]);
    }
    getRandomMovie();
  }, []);

  const stringTruncate = function (str, length) {
    const dots = str.length > length ? "..." : "";
    return str.substring(0, length) + dots;
  };
  console.log();
  return (
    <header
      className='banner'
      style={{
        backgroundImage: `url(
         'https://image.tmdb.org/t/p/original/${movie?.backdrop_path}'
       )`,
        backgroundPosition: "center center",
        backgroundSize: "cover",
      }}
    >
      <div className='banner__contents'>
        <h1 className='banner__title'>
          {movie?.title || movie?.name || movie?.original_name}
        </h1>
        <div className='banner__buttons'>
          <button className='banner__button'>Play</button>
          <button className='banner__button'>My List</button>
        </div>
        <h1 className='banner__description'>
          {movie.overview && stringTruncate(movie?.overview, 150)}
        </h1>
      </div>
      <div className='banner--fade'></div>
    </header>
  );
}

export default Banner;
